var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.required && _vm.editable)?_c('div',{staticClass:"required"},[_vm._v("必須")]):_vm._e()]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }